export namespace ApprovalTypeConstants {
  export const CLIENT_FEE_SCHEDULE = 'CLIENT_FEE_SCHEDULE';
  export const PROVIDER_FEE_SCHEDULE = 'PROVIDER_FEE_SCHEDULE';
}
